/**
 * ==================================================================================
 * Logic and functions copied from kwdowik/zoom-pan repository.
 * Separated to add in better control and customization.
 *
 * CSS:
 * - assets/scss/vendor/_zoom-and-pan.scss
 * Repository:
 * - https://github.com/kwdowik/zoom-pan
 *
 * ==================================================================================
 */

import renderer from './renderer'

const zoomAndPanClass = 'zoom-and-pan'
const ZoomAndPan = (
  container,
  minScale = 0.1,
  maxScale = 30,
  scaleSensitivity = 50
) => {
  if (
    !container ||
    !container.children ||
    !container.children[0] ||
    container.classList.contains(zoomAndPanClass)
  )
    return

  container.classList.add(zoomAndPanClass)

  let obj = {
    /**
     * @Vars
     * =====================================
     */
    container: container,
    instance: renderer({
      scaleSensitivity: scaleSensitivity,
      minScale: Math.max(0.1, minScale),
      maxScale: Math.max(minScale, maxScale),
      element: container.children[0]
    }),

    _isMouseDown: false,

    /**
     * @Public methods
     * =====================================
     */
    zoom: function(x, y, delta) {
      this.instance.zoom({
        x: x,
        y: y,
        deltaScale: delta
      })
    },

    move: function(x, y) {
      this.instance.panBy({
        originX: x,
        originY: y
      })
    },

    reset: function() {
      this.instance.reset()
    },

    /**
     * @Private methods
     * =====================================
     */

    _setMouseDown(bool) {
      if (bool === this._isMouseDown) return
      this._isMouseDown = bool
      this._setDragCursor(bool)
    },

    _setDragCursor(bool) {
      this.container.classList[bool ? 'add' : 'remove'](
        `zoom-and-pan--dragging`
      )
    },

    /**
     * Default events available on initialize
     * @return void
     */
    _bindEvents: function() {
      /**
       * Zoom event:
       * - Ctrl + scroll/pinch
       */
      this.container.addEventListener('wheel', event => {
        if (!event.ctrlKey) return
        event.preventDefault()

        this.zoom(
          event.pageX,
          event.pageY,
          Math.sign(event.deltaY) > 0 ? -1 : 1
        )
      })

      /**
       * Pan event:
       * - Shift + mouse move
       * - Drag mouse move
       */
      this.container.addEventListener('mousedown', event => {
        if (event.which === 1) {
          this._setMouseDown(true)
        }
      })
      this.container.addEventListener('mouseup', event => {
        this._setMouseDown(false)
      })
      this.container.addEventListener('mousemove', event => {
        if (event.shiftKey || this._isMouseDown) {
          event.preventDefault()
          this.move(event.movementX, event.movementY)
        }
      })

      /**
       * Reset event
       * - Double click
       */
      let touchtime = 0
      this.container.addEventListener('click', () => {
        if (new Date().getTime() - touchtime < 500) {
          this.reset()
        }
        touchtime = new Date().getTime()
      })
    }
  }

  obj._bindEvents()

  return obj
}

export default ZoomAndPan
